var _regeneratorRuntime = require("/opt/build/repo/web/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

/*! stream-to-blob-url. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = getBlobURL;

var getBlob = require('stream-to-blob');

function getBlobURL(_x, _x2) {
  return _getBlobURL.apply(this, arguments);
}

function _getBlobURL() {
  _getBlobURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, mimeType) {
    var blob, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getBlob(stream, mimeType);

          case 2:
            blob = _context.sent;
            url = URL.createObjectURL(blob);
            return _context.abrupt("return", url);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBlobURL.apply(this, arguments);
}